/** Mises en forme partagées par les écrans de la console. */

export function formaterDate(valeur: string | null, texteAbsent: string): string {
  if (!valeur) return texteAbsent;
  return new Date(valeur).toLocaleString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formaterOctets(octets: number): string {
  const unites = ['o', 'Ko', 'Mo', 'Go', 'To'];
  let valeur = octets;
  let unite = 0;
  while (valeur >= 1024 && unite < unites.length - 1) {
    valeur /= 1024;
    unite += 1;
  }
  return `${valeur.toFixed(valeur >= 10 || unite === 0 ? 0 : 1)} ${unites[unite]}`;
}

export function formaterDuree(ms: number): string {
  const minutes = Math.round(ms / 60000);
  if (minutes < 60) return `${minutes} min`;
  const heures = Math.floor(minutes / 60);
  const reste = minutes % 60;
  return reste === 0 ? `${heures} h` : `${heures} h ${reste} min`;
}
